<div class="balance-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Prompt -->
  <div class="prompt-bar">
    <span class="prompt-icon" aria-hidden="true">⚖️</span>
    <span class="prompt-text">{{ currLang === 'ar' ? 'وازِن الميزان:' : 'Balance the scale:' }}</span>
    <span class="conv">
      <span class="from">{{ round.fromValue }} {{ round.fromUnit }}</span>
      <span class="eq">=</span>
      <span class="to">? {{ round.toUnit }}</span>
    </span>
  </div>

  <!-- Reference chart -->
  <div class="ref-card">
    <span class="ref-title">{{ currLang === 'ar' ? 'التحويلات المترية' : 'Metric conversions' }}</span>
    <div class="ref-row" [class.on]="round.measure === 'length'">
      km <b>×1000</b> m <b>×100</b> cm <b>×10</b> mm
    </div>
    <div class="ref-row" [class.on]="round.measure === 'capacity'">
      L <b>×1000</b> mL
    </div>
    <div class="ref-row" [class.on]="round.measure === 'mass'">
      kg <b>×1000</b> g
    </div>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-balance-it-stage
      [round]="round"
      [roundKey]="currentRound"
      [interactive]="!resolving"
      [currLang]="currLang"
      (solved)="onSolved()">
    </app-balance-it-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn nudge-btn" [disabled]="resolving" (click)="nudge(-1)" aria-label="less">−</button>
    <span class="nudge-hint">{{ currLang === 'ar' ? 'اسحب المؤشر لموازنة' : 'drag the slider to balance' }}</span>
    <button class="ctrl-btn nudge-btn" [disabled]="resolving" (click)="nudge(1)" aria-label="more">+</button>
    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
    </button>
  </div>

  <!-- Success -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <span class="success-icon" aria-hidden="true">⚖️</span>
      <span class="success-eq">{{ round.fromValue }} {{ round.fromUnit }} = {{ round.answer }} {{ round.toUnit }}</span>
      <span class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</span>
    </div>
  </div>

  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
